@import "src/style/lib";

.product-header {
  display: flex;
  gap: 1rem;

  .product-header-main {
    flex: 0 1 100%;
  }
  .product-header-aside {
    flex: 0 0 24rem;
    padding: 0 1rem;
  }

  @include media-breakpoint-down("lg") {
    flex-direction: column;
    .product-header-aside {
      flex: none;
    }
  }
}

.product-name {
  margin: 0.25em 0 0.5em;
  @include media-breakpoint-down("lg") {
    margin: 0 0 0.25em;
  }
}

.tagline {
  line-height: 2rem;
  margin-top: 0.5rem;
  margin-bottom: 0.4rem;
  font-size: 1.25rem;
}

.prices {
  margin-bottom: 2rem;
}

.feature-icons {
  display: flex;
  flex-wrap: wrap;
  column-gap: 0.5rem;
  row-gap: 1rem;
  margin-left: -0.4rem;
  margin-bottom: 1rem;

  .spec-wrapper {
    flex: 0 0 4.8rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
  .spec-wrapper .spec-icon {
    width: 4rem;
    color: #959797;
    margin-right: 0;

    svg {
      height: auto;
      vertical-align: baseline;
    }
  }
  .spec-wrapper .spec-icon-label {
    text-align: center;
    font-size: 0.7em;
    line-height: 1.1em;
    margin-top: 0.1em;
  }
}


.product-description {
  column-gap: 8rem;
  padding: 3rem 4rem;

  @include media-breakpoint-down("sm") {
    flex: 0 0 100%;
    padding: 3rem 1rem;
  }
  @include media-breakpoint-between("sm", "lg") {
    flex: 0 0 50%;
    padding: 3rem 2rem;
  }

  > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  @include media-breakpoint-up("lg") {
    column-count: 2;
  }
}

.product-specification {
  p {
    line-height: 1.375;
  }

  img {
    max-width: 100%;
  }

  svg.sizefloor {
    height: 360px;
    margin-bottom: 1rem;
  }

  ul {
    list-style: none;
    margin-left: 0;
  }

  a.document {
    color: inherit;
    font-weight: 600;
  }
}

.product-variants {
  .spec-header {
    text-transform: uppercase;
    font-weight: 400;
    margin-bottom: 0;
  }
  .variant-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5em;
    border-top: 1px solid var(--bs-bjelin-grey);
    padding-top: 0.75em;
    margin-bottom: 2rem;
    a {
      flex: 0 0 6em;
      color: $body-color;
      padding: 0.5em 0.5em;
      border-radius: 0.75em;
      border: 2px solid transparent;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      line-height: 1.1em;
      row-gap: 3px;
      transition: border 0.4s ease-in-out;
      .spec-icon {
        margin-right: 0;
        svg {
          color: $body-color;
          height: 4em;
        }
      }
      .price {
        font-weight: 600;
      }

      &:hover {
        border-color:$highlight-background-color;
      }

      &.active {
        background-color: $highlight-background-color;
        color: #fff;
        border-color:$highlight-background-color;
        .spec-icon {
          svg {
            color: #fff;
            height: 4em;
          }
        }
      }

    }
  }
}